import React, { useRef } from 'react';
import './index.scss';
import _ from 'lodash';
import { func, object, bool } from 'prop-types';
import { useTranslation } from 'react-i18next';
import PasswordComp from '../PasswordComponent';
import Dialog from '../Dialog';
import DialogCloseButton from '../Dialog/DialogCloseButton';

const PasswordModal = ({
  closePasswordModal,
  formData,
  handleFormState,
  submitForm,
  pwdLoader
}) => {
  const { t } = useTranslation();
  const closeButtonRef = useRef();

  const setFocusToCloseButton = event => {
    if (!_.isEmpty(event.relatedTarget)) {
      let relatedClassName = event.relatedTarget.className;
      if (relatedClassName.includes('dialogComponent')) {
        return;
      } else {
        closeButtonRef.current.focus();
      }
    }
  };

  return (
    <div className="mainModal passwordModal">
      <div className="transparentBg" onClick={() => closePasswordModal()}></div>
      <Dialog
        className="modalContent"
        onBlur={setFocusToCloseButton}
        escKeyFunction={() => closePasswordModal()}
      >
        <div className="modalHeader" role="status">
          <h1 id="dialogTitleHeading">{t('Almost done!')}</h1>
          <DialogCloseButton
            ref={closeButtonRef}
            className="closeModal"
            onClick={() => closePasswordModal()}
            img="closeBold.svg"
          />
        </div>
        <div className="modalarea">
          <h2>
            {t('Create a password to finish')} <br className="mobile-only" />
            {t('setting up your account:')}
          </h2>
          <form
            autoComplete="on"
            className="commonForm"
            onSubmit={e => {
              e.preventDefault();
              submitForm();
            }}
          >
            <PasswordComp
              formData={formData}
              handleFormState={handleFormState}
            />
            {pwdLoader ? (
              <img
                src="/content/images/loader/loading.gif"
                alt="loader"
                className="searchBarLoader"
                role="progressbar"
              />
            ) : (
              <button
                disabled={!_.isValidPassword(formData)}
                data-testid="createaccount"
                className="dialogComponent createAccount button pink sc-btn-cyan themeFocus"
                type="submit"
              >
                {t('Create account')}
              </button>
            )}
          </form>
        </div>
      </Dialog>
    </div>
  );
};

PasswordModal.propTypes = {
  closePasswordModal: func,
  formData: object,
  handleFormState: func,
  submitForm: func,
  pwdLoader: bool
};

PasswordModal.defaultProps = {
  closePasswordModal: () => {},
  formData: {},
  handleFormState: () => {},
  submitForm: () => {},
  pwdLoader: false
};

export default PasswordModal;
